import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import BillingsBasic from '@/plugins/graphql/queries/v2/billings-basic.gql';
import MerchantDetails from '@/components/v2/network_distributor/MerchantDetails.vue';
import Billings from '@/components/v2/Billings';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import BillingApproved from '@/plugins/graphql/mutations/v2/billing/billing-approved.gql';
import BillingRejected from '@/plugins/graphql/mutations/v2/billing/billing-rejected.gql';
import ActionButton from '@/components/action_button/Index.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import { Mutation } from 'vuex-class';
let MerchantBillingHistory = class MerchantBillingHistory extends Mixins(ViewportSizeMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.selectedBillingUuid = '';
        this.action = '';
        this.mutationOnFlight = false;
    }
    get merchantUuid() {
        return this.$route.params.merchantUuid;
    }
    get headers() {
        return [
            {
                text: 'BILLING NO',
                value: 'referenceNumber',
                align: 'left',
                sortable: false,
            },
            {
                text: 'BILLING PERIOD',
                valueFrom: 'formattedBillingStartDate',
                valueTo: 'formattedBillingEndDate',
                align: 'left',
                sortable: false,
                range: true,
            },
            {
                text: 'AMOUNT',
                value: 'billingAccumulatedAmount',
                align: 'left',
                sortable: false,
                isCurrency: true,
            },
            {
                text: 'DUE DATE',
                value: 'formattedBillingDueDate',
                align: 'left',
                sortable: false,
            },
            {
                text: 'TIER TYPE',
                value: 'humanizedTierType',
                align: 'left',
                sortable: false,
            },
            {
                text: 'STATUS',
                value: 'humanizedStatus',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DEPOSIT SLIP',
                value: 'depositSlip',
                align: 'left',
                sortable: false,
                isDepositSlip: true,
            },
            {
                text: '',
                value: 'actions',
                sortable: false,
            },
        ];
    }
    setSelectedBillingUuid(uuid, action) {
        this.selectedBillingUuid = uuid;
        this.action = action;
        this.showConfirmationDialog();
    }
    onBillingPayment(uuid) {
        this.selectedBillingUuid = uuid;
        this.$refs.payment.showDialog();
    }
    async approveOrRejectBilling() {
        this.mutationOnFlight = true;
        const mutation = this.action === 'confirm' ? BillingApproved : BillingRejected;
        await this.$apollo
            .mutate({
            mutation,
            variables: {
                input: {
                    billingUuid: this.selectedBillingUuid,
                },
            },
            refetchQueries: [
                {
                    query: BillingsBasic,
                    variables: {
                        appUuid: this.merchantUuid,
                    },
                },
            ],
        })
            .then(() => {
            const msg = `Billing ${this.action === 'confirm' ? 'Confirmed' : 'Rejected'} Successfully`;
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.selectedBillingUuid = '';
            this.action = '';
            this.hideConfirmationDialog();
            this.mutationOnFlight = false;
        });
    }
    get dialogTitle() {
        return `${this.action === 'confirm' ? 'Confirm' : 'Reject'} Billing`;
    }
    get dialogMessage() {
        return `Are you sure you want to ${this.action} this billing payment?`;
    }
    isPaid(status) {
        return status.toLowerCase() === 'paid';
    }
};
__decorate([
    Mutation('showConfirmationDialog')
], MerchantBillingHistory.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], MerchantBillingHistory.prototype, "hideConfirmationDialog", void 0);
MerchantBillingHistory = __decorate([
    Component({
        components: {
            AppBasicDetails,
            MerchantDetails,
            Billings,
            ActionButton,
            ConfirmationDialog,
        },
    })
], MerchantBillingHistory);
export default MerchantBillingHistory;
